<template>
  <el-row class="body-container" :gutter="24" justify="center" align="middle">
    <el-col :xs="24" :sm="15" :md="15" :lg="15" :xl="15">
      <div id="title">产品试用申请</div>
      <el-form
          :model="userFrom"
          :label-position=labelPosition
          :rules="rules"
      >
        <el-form-item prop="userName">
          <el-input v-model="userFrom.userName" placeholder="姓名"/>
        </el-form-item>
        <el-form-item prop="userPhone">
          <el-input v-model="userFrom.userPhone" placeholder="手机号" clearable maxlength="11"/>
        </el-form-item>
        <el-form-item prop="companyName">
          <el-input v-model="userFrom.companyName" placeholder="公司名称"/>
        </el-form-item>
        <el-form-item prop="companyAddress">
          <el-input v-model="userFrom.companyAddress" placeholder="公司地址"/>
        </el-form-item>
        <el-form-item prop="reqInfo">
          <el-input id='reqInfo' v-model="userFrom.reqInfo" type="textarea" placeholder="需求描述"/>
        </el-form-item>
        <!--        <el-row justify="start">-->
        <!--          <p>我们将于1个工作日内与您取得联系。</p>-->
        <!--          <p>或直接拨打电话0551-64232110</p>-->
        <!--        </el-row>-->
        <div class="parent-container">
          <el-form-item>
            <el-button class="parent-container" type="primary" @click="onSubmit">提交申请</el-button>
            <el-button class="parent-container" @click="resetForm()">清空</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-col>
  </el-row>

</template>
<script setup>
import {reactive, ref} from 'vue'
import request from "@/api/request";
import {ElMessageBox} from "element-plus";

const labelPosition = ref("right")

const validatePhone = (rule, value, callback) => {
  const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
  if (!regExp.test(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

const rules = reactive({
  userName: [{required: true, message: '非空选项必填', trigger: 'blur'},],
  userPhone: [
    {required: true, message: '请输入手机号', trigger: 'blur'},
    {required: true, validator: validatePhone, trigger: 'blur'}
  ],
  companyName: [{required: true, message: '请输入公司名称', trigger: 'blur'}]
})

const userFrom = reactive({
  userName: '',
  userPhone: '',
  companyName: '',
  companyAddress: '',
  reqInfo: ''
})


function resetForm() {
  userFrom.userName = ''
  userFrom.userPhone = ''
  userFrom.companyName = ''
  userFrom.companyAddress = ''
  userFrom.reqInfo = ''
}

function isEmpty(value) {
  return value === null || value === undefined || value === '';
}

function onSubmit() {
  if (isEmpty(userFrom.userName) || isEmpty(userFrom.userPhone)) {
    ElMessageBox({
      title: '操作失败',
      message: "用户名和手机号必须填写"
    })
  } else {
    request.post("/user/form", userFrom).then(response => {
      // 处理成功响应
      console.log(response.data.msg);
      ElMessageBox({
        title: response.data.msg,
        message: "我们将于1个工作日内与您取得联系,或直接拨打电话 0551-64232110"
      })
      resetForm()
    })
  }
}

</script>

<style>
#title {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  padding: 20px;
  /*padding-left: 100px;*/
}

.body-container {

}

.parent-container {
  display: flex;
  justify-content: center;
}

#reqInfo {
  height: 100px;
}

.el-row {
  padding-top: 20px;
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>
